import { pollWorkerStatus } from './worker'
import { tagError } from './tagmanager'
import { toggle } from './ui'

export const ActionTypes = {
  POLLING_BEGIN: 'POLLING_START',
  POLLING_SUCCESS: 'POLLING_SUCCESS',
  POLLING_FAILURE: 'POLLING_FAILURE',
  POLLING_CANCEL: 'POLLING_CANCEL',
  POLLING_STATUS: 'POLLING_STATUS',
  WORKER_STATUS_POLL: 'WORKER_STATUS_POLL',
}

export const pollingSuccess = (jobId, content) => ({
  type: ActionTypes.POLLING_SUCCESS,
  jobId,
  content,
})

export const pollingFailure = (jobId, error, status) => dispatch => {
  dispatch(tagError('failure', jobId))
  const action = {
    type: ActionTypes.POLLING_FAILURE,
    jobId,
    error,
    status: {
      error: true,
    },
  }
  if (status) {
    action.status.status = status.status
    action.status.msg = status.msg
    action.status.done = status.done
  }
  return dispatch(action)
}

export const pollingStatus = (jobId, status) => ({
  type: ActionTypes.POLLING_STATUS,
  status: {
    isPolling: true,
    status: status.status,
    done: status.done,
    msg: status.msg,
  },
  jobId,
})

export const pollingBegin = jobId => ({
  type: ActionTypes.POLLING_BEGIN,
  jobId,
})

export const pollingCancel = jobId => ({
  type: ActionTypes.POLLING_CANCEL,
  status: {
    isPolling: false,
    isCanceled: true,
    msg: 'canceled',
  },
  jobId,
})

export const pollingPoll = options => (dispatch, getState) => {
  const jobState = getState().polling[options.jobId]
  if (jobState && jobState.isCanceled) {
    return
  }

  try {
    options
      .pollFunction(options.halData)
      .then(result => {
        dispatch(pollingStatus(options.jobId, result))
        if (result.done) {
          if (result.status === 'ok') {
            return options.getResultFunction().then(workerResult => {
              dispatch(pollingSuccess(options.jobId, workerResult))
              options.onSuccess(workerResult)
            })
          }
          if (result.status === 'error') {
            dispatch(toggle(options.jobId, true))
            return Promise.reject(result.msg)
          }
          dispatch(toggle(options.jobId, true))
          return Promise.reject(new Error('backend error not provided to frontend'))
        }
        return setTimeout(() => dispatch(pollingPoll(options)), 1000)
      })
      .catch(error => {
        dispatch(toggle(options.jobId, true))
        dispatch(pollingFailure(options.jobId, error))
        options.onFailure(error)
      })
  } catch (error) {
    dispatch(toggle(options.jobId, true))
    dispatch(pollingFailure(options.jobId, error))
    options.onFailure(error)
  }
}

export const pollingStart = options => dispatch => {
  const defaults = {
    pollFunction: halData => dispatch(pollWorkerStatus(halData)),
    onFailure: error => console.log('fail', error), // eslint-disable-line no-console
  }
  const finalOptions = Object.assign(defaults, options)
  dispatch(pollingBegin(options.jobId))
  try {
    finalOptions.startFunction().then(halData => {
      const finalOptionsWithHalData = Object.assign({ halData }, finalOptions)
      dispatch(pollingPoll(finalOptionsWithHalData))
    })
  } catch (error) {
    dispatch(pollingFailure(finalOptions.jobId, error))
  }
}
